var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coin-network-details"},[_c('Typography',{staticClass:"coin-network-details__title",attrs:{"as":"h2","variant":_vm.$mobileCheck() ? 'headline4' : 'headline2'}},[_vm._v("\n    "+_vm._s(_vm.$t((_vm.tPrefix + ".title")))+"\n  ")]),_c('Typography',{staticClass:"coin-network-details__description",attrs:{"as":"p","variant":_vm.$mobileCheck() ? 'body4' : 'body3'},domProps:{"innerHTML":_vm._s(
      _vm.$t(
        (_vm.tPrefix + ".description" + (_vm.needsOnboardingCall ? 'WithOnboardingCall' : '')),
        {
          delayedPeriodDays: _vm.subscription.defaultDelayPeriod
        }
      )
    )}}),_c('DelayedPlanOverview',{attrs:{"subscription":_vm.subscription}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }